import { useState } from 'react';
import { ThumbsUp, ThumbsDown, Send } from 'lucide-react';
import { submitFeedback } from '../utils/feedbackClient';
interface Props {
  messageId: string;
  query?: string;
  mode: 'nlq' | 'workfront';
}
const STORAGE_PREFIX = 'ai-feedback-';
const MAX_COMMENT = 500;
function getStoredFeedback(messageId: string): {
  rating?: 'up' | 'down';
  comment?: string;
} | null {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + messageId);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
function storeFeedback(messageId: string, rating: 'up' | 'down', comment?: string): void {
  try {
    localStorage.setItem(STORAGE_PREFIX + messageId, JSON.stringify({
      rating,
      comment
    }));
  } catch {/* quota exceeded */}
}
export function FeedbackBar({
  messageId,
  query,
  mode
}: Props) {
  const stored = getStoredFeedback(messageId);
  const [rating, setRating] = useState<'up' | 'down' | null>(stored?.rating ?? null);
  const [comment, setComment] = useState(stored?.comment ?? '');
  const [showComment, setShowComment] = useState(false);
  const [justSubmitted, setJustSubmitted] = useState(!!stored);
  const handleRate = async (value: 'up' | 'down') => {
    // console.log('[FeedbackBar] handleRate:', value, 'current rating:', rating);
    const newRating = rating === value ? null : value;
    setRating(newRating);
    if (newRating) {
      storeFeedback(messageId, newRating);
      setShowComment(true);
      setJustSubmitted(true);
      await submitFeedback({
        messageId,
        rating: newRating,
        query,
        mode
      });
    } else {
      localStorage.removeItem(STORAGE_PREFIX + messageId);
      setShowComment(false);
      setComment('');
    }
  };
  const handleSendComment = async () => {
    if (!rating) return;
    storeFeedback(messageId, rating, comment);
    setShowComment(false);
    await submitFeedback({
      messageId,
      rating,
      comment,
      query,
      mode
    });
  };
  return <div className="ai-feedback-bar" data-id="element-116" data-mp="25ab72lslczaz">
      <div className="ai-feedback-actions" data-id="element-117" data-mp="2599v8f3r48s7">
        <button className={`ai-feedback-btn ${rating === 'up' ? 'active' : ''}`} onClick={() => void handleRate('up')} title="Helpful" data-id="element-118" data-mp="20b83l5s9f154">
          <ThumbsUp size={13} data-id="element-119" data-mp="1vdq2g1khhq7o" />
        </button>
        <button className={`ai-feedback-btn ${rating === 'down' ? 'active' : ''}`} onClick={() => void handleRate('down')} title="Not helpful" data-id="element-120" data-mp="1r98km7xopmzj">
          <ThumbsDown size={13} data-id="element-121" data-mp="1hk748gn893l1" />
        </button>
        {justSubmitted && rating && <span className="ai-feedback-thanks" data-id="element-122" data-mp="1ckui5y46k0ji">Thanks for your feedback</span>}
      </div>

      {showComment && rating && <div className="ai-feedback-comment" data-id="element-123" data-mp="17nlvplc01acg">
          <input type="text" className="ai-feedback-input" placeholder="Tell us more (optional)" value={comment} onChange={e => setComment(e.target.value.slice(0, MAX_COMMENT))} onKeyDown={e => {
        if (e.key === 'Enter') void handleSendComment();
      }} autoFocus data-id="element-124" data-mp="13kpkwgspaij2" />
          <button className="ai-feedback-send" onClick={() => void handleSendComment()} title="Send feedback" data-id="element-125" data-mp="3f9vt6biel4f2">
            <Send size={12} data-id="element-126" data-mp="3o7fvzovwz8rs" />
          </button>
        </div>}
    </div>;
}